import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_CREATE_TICKET from '../../../api/apiCreateTicket';
import Dropdown from '../../../components/Common/Dropdown';
import DropdownFilter from '../../../components/Common/DropdownFilter';
import DropdownButtonFilter from '../../../components/Common/DropdownButtonFilter';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import IconUpload from '../../../assets/icons/IconUpload';
import IconStatusCheck from '../../../assets/icons/IconStatusCheck';
import IconAttachmentPicture from '../../../assets/icons/IconAttachmentPicture';
import IconCloseBlue from '../../../assets/icons/IconCloseBlue';
import ButtonBorderDarkBlue from '../../../components/Button/ButtonBorderDarkBlue';
import ButtonLightBlue from '../../../components/Button/ButtonLightBlue';
import { CheckPermissionComponent } from '../../../util/permission';
import { TICKET_CREATE_INSERT } from '../../../constants/menuPermissionConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';

class TicketListCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                id: 0,
                reset: false
            },
            contact: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                reset: false
            },
            principal: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                cid: 0,
                reset: false
            },
            channel: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            name: '',
            phone: '',
            email: '',
            nsCode: {
                page: 1,
                limit: 100,
                data: [],
                value: '',
                reset: false
            },
            branchId: {
                page: 1,
                limit: 100,
                data: [],
                value: '',
                reset: false
            },
            licenseStatus: '',
            issueTitle: '',
            issueDescription: '',
            complaint: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            complaintCategory: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            complaintSub: {
                page: 1,
                limit: 100,
                data: [],
                value: ''
            },
            note: '',
            attachment: [],
            isNewContact: false,
            isPicDisabled: true,
            isSubmitted: false,
            showAttachmentModal: false,
            showSuccessAlert: false,
            successMessage: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListCustomer = () => {
        API_CREATE_TICKET.getListCustomer(this.state.customer.page, this.state.customer.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchCustomer = keyword => {
        API_CREATE_TICKET.getSearchCustomer(this.state.customer.page, this.state.customer.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListPrincipal = id => {
        API_CREATE_TICKET.getListPrincipal(this.state.principal.page, this.state.principal.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchPrincipal = keyword => {
        API_CREATE_TICKET.getSearchPrincipal(this.state.principal.page, this.state.principal.limit, keyword, this.state.customer.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListContact = id => {
        API_CREATE_TICKET.getListContact(this.state.contact.page, this.state.contact.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        contact: {
                            ...this.state.contact,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchContact = keyword => {
        API_CREATE_TICKET.getSearchContact(this.state.contact.page, this.state.contact.limit, keyword, this.state.customer.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        contact: {
                            ...this.state.contact,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListChannel = () => {
        API_CREATE_TICKET.getListChannel(this.state.channel.page, this.state.channel.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        channel: {
                            ...this.state.channel,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListComplaint = () => {
        API_CREATE_TICKET.getListComplaint(this.state.complaint.page, this.state.complaint.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let complaintData = getContent(res).map(complaint => ({
                        value: complaint.id,
                        label: complaint.complaint_description
                    }))
                    this.setState({
                        complaint: {
                            ...this.state.complaint,
                            data: complaintData
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListComplaintCategory = () => {
        API_CREATE_TICKET.getListComplaintCategory(this.state.complaintCategory.page, this.state.complaintCategory.limit, this.state.complaint.value.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let complaintCategoryData = getContent(res).map(complaintCategory => ({
                        value: complaintCategory.id,
                        label: complaintCategory.complaint_category
                    }))
                    this.setState({
                        complaintCategory: {
                            ...this.state.complaintCategory,
                            data: complaintCategoryData
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListComplaintSub = () => {
        API_CREATE_TICKET.getListComplaintSub(this.state.complaintSub.page, this.state.complaintSub.limit, this.state.complaintCategory.value.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let complaintSubData = getContent(res).map(complaintSub => ({
                        value: complaintSub.id,
                        label: complaintSub.complaint_sub
                    }))
                    this.setState({
                        complaintSub: {
                            ...this.state.complaintSub,
                            data: complaintSubData
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListNsCode = id => {
        API_CREATE_TICKET.getListNsCode(this.state.nsCode.page, this.state.nsCode.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        nsCode: {
                            ...this.state.nsCode,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListBranchId = nsCode => {
        API_CREATE_TICKET.getListBranchId(this.state.branchId.page, this.state.branchId.limit, this.state.principal.cid, nsCode, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        branchId: {
                            ...this.state.branchId,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChangeCustomer = data => {
        this.setState({
            customer: {
                ...this.state.customer,
                value: data.value,
                id: data.id
            },
            principal: {
                ...this.state.principal,
                value: 0,
                reset: true
            },
            contact: {
                ...this.state.contact,
                value: 0,
                reset: true
            },
            nsCode: {
                ...this.state.nsCode,
                value: '',
                data: [],
                reset: true
            },
            branchId: {
                ...this.state.branchId,
                value: '',
                data: [],
                reset: true
            },
            name: '',
            phone: '',
            email: '',
            isPicDisabled: true,
            isNewContact: false,
            licenseStatus: '',
        })
        this.getListContact(data.id)
        this.getListPrincipal(data.id)
    }

    handleChangePrincipal = data => {
        this.setState({
            principal: {
                ...this.state.principal,
                value: data.value,
                cid: data.cid
            },
            nsCode: {
                ...this.state.nsCode,
                value: '',
                data: [],
                reset: true
            },
            branchId: {
                ...this.state.branchId,
                value: '',
                data: [],
                reset: true
            },
            licenseStatus: ''
        })
        this.getListNsCode(data.cid)
    }

    handleChangeChannel = data => {
        this.setState({
            channel: {
                ...this.state.channel,
                value: data.value
            }
        })
    }

    handleChangeNsCode = data => {
        this.setState({
            nsCode: {
                ...this.state.nsCode,
                value: data.value
            },
            branchId: {
                ...this.state.branchId,
                value: '',
                data: [],
                reset: true
            },
            licenseStatus: ''
        })
        this.getListBranchId(data.value)
    }

    handleChangeBranchId = data => {
        this.setState({
            branchId: {
                ...this.state.branchId,
                value: data.value
            },
            licenseStatus: data.license
        })
    }

    handleChangeComplaint = async data => {
        await this.setState({
            complaint: {
                ...this.state.complaint,
                value: data
            },
            complaintCategory: {
                ...this.state.complaintCategory,
                value: ''
            },
            complaintSub: {
                ...this.state.complaintSub,
                value: ''
            }
        })
        this.getListComplaintCategory()
    }

    handleChangeComplaintCategory = async data => {
        await this.setState({
            complaintCategory: {
                ...this.state.complaintCategory,
                value: data
            },
            complaintSub: {
                ...this.state.complaintSub,
                value: ''
            }
        })
        this.getListComplaintSub()
    }

    handleChangeComplaintSub = data => {
        this.setState({
            complaintSub: {
                ...this.state.complaintSub,
                value: data
            }
        })
    }

    handleChangeContact = data => {
        this.setState({
            contact: {
                ...this.state.contact,
                value: data.value,
            },
            name: data.label,
            phone: data.phone,
            email: data.email,
            isNewContact: false,
            isPicDisabled: true
        })
    }

    handleNewDataPic = picName => {
        if (this.state.isNewContact) {
            this.setState({
                contact: {
                    ...this.state.contact,
                    value: 0
                },
                name: picName,
            })
        } else {
            this.setState({
                isPicDisabled: false,
                contact: {
                    ...this.state.contact,
                    value: 0
                },
                name: picName,
                isNewContact: true,
                phone: '',
                email: ''
            })
        }
    }

    handleChangePic = e => {
        this.setState({
            contact: {
                ...this.state.contact,
                phone: e.target.value,
            }
        })
    }

    handleResetCustomer = () => {
        this.setState({
            customer: {
                ...this.state.customer,
                reset: false
            }
        })
    }

    handleResetPrincipal = () => {
        this.setState({
            principal: {
                ...this.state.principal,
                reset: false
            }
        })
    }

    handleResetNsCode = () => {
        this.setState({
            nsCode: {
                ...this.state.nsCode,
                reset: false
            }
        })
    }

    handleResetBranchId = () => {
        this.setState({
            branchId: {
                ...this.state.branchId,
                reset: false
            }
        })
    }

    handleResetContact = () => {
        this.setState({
            contact: {
                ...this.state.contact,
                reset: false
            }
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeAttachment = e => {
        if (e.target.files.length > 5) {
            return this.setState({
                errorMessage: 'Maksimal 5 file!',
                showErrorAlertResponse: true
            })
        }

        const attachmentList = [];

        for (let atc = 0; atc < e.target.files.length; atc++) {
            const attachment = e.target.files[atc];
            if (attachment.size / 1024 / 1024 >= 2) {
                this.setState({
                    errorMessage: `Ukuran file ${attachment.name} terlalu besar!`,
                    showErrorAlertResponse: true
                })
                continue
            }
            attachmentList.push(attachment);
        }

        if (this.state.attachment.concat(attachmentList).length > 5) {
            return this.setState({
                errorMessage: 'Maksimal 5 file!',
                showErrorAlertResponse: true
            })
        }

        this.setState({ attachment: this.state.attachment.concat(attachmentList) });
    }

    handleDeleteAttachment = attachment => {
        this.setState({
            attachment: this.state.attachment.filter(item => item !== attachment)
        });
    }

    handleSubmit = () => {
        this.setState({ isSubmitted: true })

        let bodyFormData = new FormData();

        const data = {
            customer_id: this.state.customer.value,
            contact_id: this.state.contact.value,
            pic_name: this.state.name,
            phone: this.state.phone,
            principal_id: this.state.principal.value,
            ticket_from: this.state.channel.value,
            pic_email: this.state.email,
            ns_code: this.state.nsCode.value,
            branch_id: this.state.branchId.value,
            complaint_sub_id: this.state.complaintSub.value.value,
            issue_title: this.state.issueTitle,
            issue_desc: this.state.issueDescription,
            create_contact: this.state.isNewContact,
            note: this.state.note
        }

        bodyFormData.append('content', JSON.stringify(data));

        for (let index = 1; index <= this.state.attachment.length; index++) {
            const attachment = this.state.attachment[index - 1];
            bodyFormData.append('photo' + index, attachment);
        }

        API_CREATE_TICKET.postDataCreateTicket(bodyFormData, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    successMessage: getContent(res).ticket_number
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    isSubmitted: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleClose = () => {
        this.setState({ showSuccessAlert: false })
        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL)
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListCustomer();
        this.getListComplaint();
        this.getListChannel();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_CREATE_INSERT]} userPermission={this.props.userDetail.permissions}>
                <BreadCrumbs
                    parentMenu="Daftar Tiket"
                    serviceMenu="Buat Tiket"
                    title="Buat Tiket"
                />

                <div className="bg-white rounded-2xl p-8 mb-10">
                    <div>
                        <div className="grid grid-cols-4 gap-3">
                            <div>
                                <label>Nama Distributor <span className="text-darkred">*</span></label>
                                <DropdownFilter
                                    id="ddscustomer"
                                    placeholder="Pilih Distributor"
                                    searchPlaceholder="Cari Distributor"
                                    handleChange={this.handleChangeCustomer}
                                    getListData={this.getListCustomer}
                                    getSearchData={this.getSearchCustomer}
                                    data={this.state.customer.data.map(data => ({ value: data.user_nexcare_id, label: data.customer_name, id: data.id }))}
                                    reset={this.state.customer.reset}
                                    handleReset={this.handleResetCustomer}
                                />
                            </div>
                            <div>
                                <label>PIC <span className="text-darkred">*</span></label>
                                <DropdownButtonFilter
                                    id="ddspic"
                                    placeholder="Pilih PIC"
                                    searchPlaceholder="Cari PIC"
                                    buttonPlaceholder="Masukan PIC"
                                    handleChange={this.handleChangeContact}
                                    handleNewData={this.handleNewDataPic}
                                    getListData={() => this.getListContact(this.state.customer.id)}
                                    getSearchData={this.getSearchContact}
                                    data={this.state.contact.data.map(data => ({ value: data.id, label: data.pic_name, phone: data.pic_phone, email: data.email }))}
                                    reset={this.state.contact.reset}
                                    handleReset={this.handleResetContact}
                                />
                            </div>
                            <div>
                                <label>Telepon {!this.state.isPicDisabled && <span className="text-darkred">*</span>}</label>
                                <div className="form-control" style={this.state.isPicDisabled ? { backgroundColor: "#eee" } : { backgroundColor: "transparent" }}>
                                    <span className="mr-1">+62 |</span>
                                    <input
                                        type={this.state.isPicDisabled ? "text" : "number"}
                                        id="tslphone"
                                        className="outline-none custom-input w-4/5"
                                        placeholder="Tulis Nomor Telepon"
                                        value={this.state.phone}
                                        name="phone"
                                        readOnly={this.state.isPicDisabled}
                                        onChange={this.handleChange}
                                        autoComplete="off"
                                        style={this.state.isPicDisabled ? { backgroundColor: "#eee" } : { backgroundColor: "transparent" }}
                                    />
                                </div>
                            </div>
                            <div></div>
                            <div>
                                <label>Principal <span className="text-darkred">*</span></label>
                                <DropdownFilter
                                    id="ddsprincipal"
                                    placeholder="Pilih Principal"
                                    searchPlaceholder="Cari Principal"
                                    handleChange={this.handleChangePrincipal}
                                    getListData={this.getListPrincipal}
                                    getSearchData={this.getSearchPrincipal}
                                    data={this.state.principal.data.map(data => ({ value: data.user_nexcare_id, label: data.customer_name, cid: data.user_customer_map_id }))}
                                    reset={this.state.principal.reset}
                                    handleReset={this.handleResetPrincipal}
                                />
                            </div>
                            <div>
                                <label>Channel Tiket <span className="text-darkred">*</span></label>
                                <Dropdown
                                    id="ddslchannel"
                                    placeholder="Pilih Channel Tiket"
                                    handleChange={this.handleChangeChannel}
                                    data={this.state.channel.data.map(data => ({ value: data.remark, label: data.description }))}
                                />
                            </div>
                            <div>
                                <label>Alamat Email</label><br />
                                <input
                                    type="email"
                                    id="tslemail"
                                    className="form-control"
                                    placeholder="Tulis Alamat Email"
                                    value={this.state.email}
                                    name="email"
                                    readOnly={this.state.isPicDisabled}
                                    onChange={this.handleChange}
                                    autoComplete="off"
                                    style={this.state.isPicDisabled ? { backgroundColor: "#eee" } : { backgroundColor: "transparent" }}
                                />
                            </div>
                            <div></div>
                            <div>
                                <label>Kode NS</label>
                                <Dropdown
                                    id="ddslnscode"
                                    placeholder="Pilih Kode NS"
                                    handleChange={this.handleChangeNsCode}
                                    data={this.state.nsCode.data.map(data => ({ value: data.ns_code, label: data.ns_code }))}
                                    reset={this.state.nsCode.reset}
                                    handleReset={this.handleResetNsCode}
                                />
                            </div>
                            <div>
                                <label>Kode Cabang</label>
                                <Dropdown
                                    id="ddlbranchid"
                                    placeholder="Pilih Kode Cabang"
                                    handleChange={this.handleChangeBranchId}
                                    data={this.state.branchId.data.map(data => ({ value: data.branch_id, label: data.branch_id, license: data.license }))}
                                    reset={this.state.branchId.reset}
                                    handleReset={this.handleResetBranchId}
                                />
                            </div>
                            <div>
                                <label>Status</label>
                                <input
                                    type="text"
                                    id="tslstatus"
                                    className="form-control"
                                    placeholder="Status Lisensi"
                                    value={this.state.licenseStatus === "A" ? "Aktif" : this.state.licenseStatus === "E" ? "Kadaluwarsa" : ""}
                                    style={{ backgroundColor: "#eee" }}
                                    readOnly
                                />
                            </div>
                            <div className="col-span-4">
                                <label>Judul Keluhan <span className="text-darkred">* <span className="text-sm">(minimal 10 karakter)</span></span></label><br />
                                <input
                                    type="text"
                                    id="tslissuetitle"
                                    className="form-control"
                                    placeholder="Tulis Judul Keluhan"
                                    name="issueTitle"
                                    onChange={this.handleChange}
                                    minLength="10"
                                    maxLength="100"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-span-3 row-span-3">
                                <label>Deskripsi Keluhan <span className="text-darkred">* <span className="text-sm">(minimal 10 karakter)</span></span></label>
                                <textarea
                                    id="tmlissuedescription"
                                    className="form-control resize-none h-48 2xl:h-40"
                                    placeholder="Tulis Deskripsi Keluhan"
                                    name="issueDescription"
                                    onChange={this.handleChange}
                                    minLength="10"
                                    maxLength="300"
                                />
                            </div>
                            <div className="mt-6">
                                <Select
                                    id="ddscomplaint"
                                    placeholder="Pilih Produk *"
                                    options={this.state.complaint.data}
                                    value={this.state.complaint.value}
                                    onChange={this.handleChangeComplaint}
                                />
                            </div>
                            <div>
                                <Select
                                    id="ddscomplaintcategory"
                                    placeholder="Pilih Modul *"
                                    options={this.state.complaintCategory.data}
                                    value={this.state.complaintCategory.value}
                                    onChange={this.handleChangeComplaintCategory}
                                />
                            </div>
                            <div>
                                <Select
                                    id="ddscomplaintsub"
                                    placeholder="Pilih Kategori Keluhan *"
                                    options={this.state.complaintSub.data}
                                    value={this.state.complaintSub.value}
                                    onChange={this.handleChangeComplaintSub}
                                />
                            </div>
                            <div className="col-span-4 row-span-2">
                                <label>Note (untuk internal)</label>
                                <textarea
                                    id="tmlnote"
                                    className="form-control resize-none h-20"
                                    placeholder="Tulis Note"
                                    name="note"
                                    onChange={this.handleChange}
                                />
                            </div>
                            {
                                this.state.attachment.length > 0
                                && <div className="col-span-4 row-span-2">
                                    <label>Lampiran</label>
                                    <div className="pb-5 grid gap-3 grid-cols-3">
                                        {
                                            this.state.attachment.length !== 0 && this.state.attachment.map((att, idx) =>
                                                <div className="flex justify-between bg-blue-100 rounded px-5 py-2" key={idx}>
                                                    <div className="w-5/6 flex">
                                                        <IconAttachmentPicture />
                                                        <div className="ml-1 w-5/6">
                                                            <p className="text-sm truncate whitespace-nowrap">{att.name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="cursor-pointer" onClick={() => this.handleDeleteAttachment(att)}>
                                                        <IconCloseBlue />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        <span className="text-darkred">* keterangan wajib diisi</span>
                        <div className="flex justify-center items-center">
                            <button type="button" id="btnattachment" className="bg-darkblue rounded text-white outline-none focus:outline-none px-10 py-2 mr-1" onClick={() => this.setState({ showAttachmentModal: true })}>Lampiran</button>
                            <button type="button" id="btncreateticket" className={this.state.isSubmitted ? "bg-lightblue rounded text-white outline-none focus:outline-none px-10 py-2 cursor-not-allowed ml-1" : "bg-lightblue rounded text-white outline-none focus:outline-none px-10 py-2 ml-1"} disabled={this.state.isSubmitted} onClick={() => this.handleSubmit()}>Buat Tiket</button>
                        </div>
                    </div>
                </div>

                <div className={this.state.showAttachmentModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/3">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnattachment" onClick={() => this.setState({ showAttachmentModal: false })} />
                            </div>
                            <div className="body-attachment">
                                <p className="text-darkblue text-center text-3xl font-medium">Lampirkan File</p>
                                <div className="text-gray-600 flex items-center flex-col border border-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg relative mt-5 py-5">
                                    <IconUpload />
                                    <p>Seret dan letakan file di sini</p>
                                    <p>ATAU</p>
                                    <p className="text-darkblue font-medium">Ambil File</p>
                                    <input type="file" id="fupattachment" name="attachment" className="absolute w-full h-full top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" onChange={this.handleChangeAttachment} multiple />
                                    <p>File maksimal 2 MB</p>
                                </div>
                                <div className="py-5">
                                    {
                                        this.state.attachment.length !== 0 && this.state.attachment.map((att, idx) =>
                                            <div className="flex justify-between my-2" key={idx}>
                                                <div className="w-5/6 flex">
                                                    <IconAttachmentPicture />
                                                    <div className="ml-1 w-5/6">
                                                        <p className="text-sm truncate whitespace-nowrap">{att.name}</p>
                                                        <p className="text-xs text-gray-500">{Math.round(att.size / 1024 / 1024 * 100) / 100} MB</p>
                                                    </div>
                                                </div>
                                                <IconStatusCheck />
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="flex justify-center">
                                    <ButtonBorderDarkBlue type="button" id="btncancel" className="mt-2 mr-1" onClick={() => this.setState({ showAttachmentModal: false })}>
                                        Batal
                                    </ButtonBorderDarkBlue>
                                    <ButtonLightBlue type="button" id="btnsave" className="mt-2 ml-1" onClick={() => this.setState({ showAttachmentModal: false })}>
                                        Simpan
                                    </ButtonLightBlue>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title={`Berhasil membuat tiket baru ${this.state.successMessage}!`} close={() => this.handleClose()} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketListCreate);